import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		userName: '',
		// 移除 ipWarning
	},
	mutations: {
		getUserName(state, date) {
			state.userName = date;
		},
		// 移除 setIpWarning
	},
	actions: {

	},
	modules: {}
})